import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";

const GenericTabView = ({ tabs }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Check if tabs have a key property (for query param support)
  const hasKeyProperty = tabs.some((tab) => tab.key);

  // Get active tab from query param or use default
  const activeTab = hasKeyProperty
    ? searchParams.get("type") || tabs[0]?.key || "1"
    : undefined;

  const handleTabChange = (key: string) => {
    if (hasKeyProperty) {
      setSearchParams({ type: key });
    }
  };

  return (
    <Tabs
      defaultActiveKey={hasKeyProperty ? undefined : "1"}
      activeKey={hasKeyProperty ? activeTab : undefined}
      onChange={handleTabChange}
      items={tabs.map((val, i) => {
        const { title, Icon, component, key } = val || {};
        return {
          label: (
            <span>
              {Icon}
              {title}
            </span>
          ),
          key: key || i,
          children: <div>{component}</div>,
        };
      })}
    />
  );
};
export default GenericTabView;
